var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailMailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 326,
    viewBox: "0 0 326 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1449_2012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326 249.323H0V249.486H326V249.323Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.239 256.229H223.808V256.392H246.239V256.229Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3979 256.31H59.7759V256.473H72.3979V256.31Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.652 255.928H138.068V256.091H163.652V255.928Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.416 253.61H125.979V253.773H137.416V253.61Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.81 253.691H242.264V253.854H276.81V253.691Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.533 220.246H28.6327C26.5809 220.246 24.9111 218.576 24.9111 216.524V39.5502C24.9111 37.4984 26.5809 35.8286 28.6327 35.8286H154.533C156.584 35.8286 158.254 37.4984 158.254 39.5502V216.524C158.254 218.576 156.584 220.246 154.533 220.246ZM28.6327 35.9923C26.6702 35.9923 25.0741 37.5884 25.0741 39.5509V216.525C25.0741 218.487 26.6702 220.083 28.6327 220.083H154.533C156.495 220.083 158.091 218.487 158.091 216.525V39.5502C158.091 37.5884 156.495 35.9916 154.533 35.9916L28.6327 35.9923Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.558 220.246H169.658C167.607 220.246 165.938 218.576 165.938 216.524V39.5502C165.938 37.4984 167.607 35.8286 169.658 35.8286H295.558C297.611 35.8286 299.28 37.4984 299.28 39.5502V216.524C299.281 218.576 297.611 220.246 295.558 220.246ZM169.658 35.9923C167.697 35.9923 166.101 37.5884 166.101 39.5509V216.525C166.101 218.487 167.697 220.083 169.658 220.083H295.558C297.521 220.083 299.117 218.487 299.117 216.525V39.5502C299.117 37.5884 297.521 35.9916 295.558 35.9916L169.658 35.9923Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.432 167.713C278.409 155.503 285.735 142.374 284.513 128.792C283.292 115.209 270.385 112.244 272.827 100.731C275.659 87.3831 268.118 74.5674 259.57 74.5674C251.023 74.5674 243.482 87.3831 246.314 100.731C248.756 112.244 235.848 115.209 234.627 128.792C233.406 142.374 240.732 155.502 232.708 167.713C224.685 179.923 226.79 196.096 231.313 204.122C232.559 206.333 234.025 208.291 235.624 210.023C248.456 223.92 270.685 223.92 283.517 210.023C285.116 208.291 286.583 206.334 287.829 204.122C292.35 196.096 294.456 179.923 286.432 167.713Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.625 249.323H255.514V181.037C255.514 178.806 257.339 176.981 259.57 176.981C261.8 176.981 263.625 178.806 263.625 181.037V249.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.581 249.323H197.539V181.042C197.539 178.005 200.023 175.521 203.06 175.521C206.097 175.521 208.581 178.006 208.581 181.042V249.323Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.059 230.904C221.845 230.904 237.073 215.676 237.073 196.89C237.073 178.105 221.845 162.877 203.059 162.877C184.274 162.877 169.046 178.105 169.046 196.89C169.046 215.676 184.274 230.904 203.059 230.904Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.03 186.692C244.815 179.508 240.437 172.237 233.253 170.452C226.069 168.667 218.798 173.045 217.013 180.229C215.228 187.413 219.605 194.684 226.79 196.469C233.974 198.254 241.245 193.877 243.03 186.692Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.391 176.797C184.095 172.471 181.16 168.392 176.833 167.687C172.507 166.983 168.428 169.918 167.723 174.244C167.019 178.57 169.954 182.649 174.281 183.353C178.607 184.058 182.686 181.123 183.391 176.797Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.179 176.982C187.256 176.982 189.749 174.488 189.749 171.412C189.749 168.336 187.256 165.842 184.179 165.842C181.103 165.842 178.609 168.336 178.609 171.412C178.609 174.488 181.103 176.982 184.179 176.982Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.989 208.57C127.325 209.411 122.416 211.464 118.178 214.221C118.137 209.06 117.193 204.159 114.767 200.2C111.075 203.799 108.084 208.452 105.669 213.458C104.764 204.047 102.293 194.93 96.8222 189.168C88.6252 194.324 84.4003 202.918 82.3908 212.019C79.1249 206.187 74.619 200.804 68.3969 196.89C63.3817 202.173 61.7804 209.476 61.9134 216.957C56.2163 210.324 49.8886 205.145 43.7213 204.537C42.2028 215.044 45.4367 224.95 49.5463 232.761C54.937 243.006 65.6611 249.324 77.238 249.324H104.025C115.443 249.324 126.147 243.232 131.503 233.151C134.896 226.765 136.509 218.541 132.989 208.57Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.351 73.1147C128.661 63.4188 126.034 56.5161 117.942 56.5161C112.867 56.5161 106.575 59.233 100.447 63.6568C99.7548 61.1349 97.8054 59.6235 94.6686 59.6235C89.1488 59.6235 81.5399 64.2932 75.5709 70.8816C74.1267 69.4127 72.0364 68.5129 69.3508 68.3682C64.0683 68.0709 57.6696 70.7538 52.1067 75.1183C51.6249 74.3881 50.7988 73.9297 49.6584 73.8619C46.6142 73.6924 42.4936 76.4008 40.4463 79.9073C40.3185 80.1283 40.2057 80.3402 40.0923 80.5527H46.4154H51.4462H68.9218H77.5217H84.2086H94.5082H96.3775H121.927H126.958C127.218 77.4955 126.677 74.9397 125.351 73.1147Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.619 131.986C127.236 127.25 125.953 123.877 122 123.877C119.521 123.877 116.448 125.205 113.455 127.366C113.117 126.134 112.165 125.396 110.633 125.396C107.936 125.396 104.22 127.677 101.304 130.896C100.598 130.178 99.5773 129.738 98.2655 129.668C95.6849 129.522 92.5598 130.834 89.8423 132.965C89.6069 132.608 89.2033 132.384 88.6465 132.351C87.1593 132.269 85.1466 133.592 84.1464 135.304C84.0838 135.412 84.0291 135.516 83.9736 135.62H87.0622H89.5195H98.0562H102.257H105.524H110.555H111.468H123.948H126.405C126.531 134.126 126.267 132.877 125.619 131.986Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.484 96.1656C223.154 96.1173 222.818 96.0925 222.477 96.0925C222.79 91.3616 220.981 88.3409 217.118 88.3409C214.331 88.3409 210.911 89.9181 207.425 92.5867C208.422 83.404 205.228 77.4355 197.996 77.4355C192.161 77.4355 184.775 81.3176 177.479 87.6498C176.84 84.0468 174.69 81.8874 171.078 81.8874C164.733 81.8874 155.717 88.5593 148.488 97.9729C148.488 97.9729 148.485 97.9853 148.479 97.9729C146.917 95.8741 144.57 94.576 141.485 94.3699C135.444 93.9455 127.942 97.7786 121.291 104.026C120.785 102.97 119.864 102.316 118.546 102.23C115.242 102 110.689 105.445 108.045 110.055H115.752H120.977H141.071H150.481H158.861H170.762H193.248H202.013H205.132H217.608H228.801C231.637 103.068 229.378 96.9545 223.484 96.1656Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 278.77C232.818 278.77 289.416 275.464 289.416 271.387C289.416 267.31 232.818 264.004 163 264.004C93.1827 264.004 36.5845 267.31 36.5845 271.387C36.5845 275.464 93.1827 278.77 163 278.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2939 255.24L245.134 226.535L277.137 243.922L54.2939 255.24Z",
    fill: "#3477B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M54.2939 255.24L245.134 226.535L277.137 243.922L54.2939 255.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2939 255.24L245.134 226.535L247.424 264.911L54.2939 255.24Z",
    fill: "#3477B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.2939 255.24L245.134 226.535L247.424 264.911L54.2939 255.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2939 255.24L215.955 245.7L247.424 264.911L54.2939 255.24Z",
    fill: "#3477B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M54.2939 255.24L215.955 245.7L247.424 264.911L54.2939 255.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.728 273.257L119.53 274.072L139.275 278.856L139.473 278.041L119.728 273.257Z",
    fill: "#3477B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.196 280.15L147.998 280.965L155.101 282.686L155.299 281.871L148.196 280.15Z",
    fill: "#3477B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2935 255.24L215.954 245.7L197.264 289.873L54.2935 255.24Z",
    fill: "#3477B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.349 217.793L173.207 217.873L158.143 217.873L88.0013 217.793L88.0013 126.709L243.349 126.709L243.349 217.793Z",
    fill: "#EE8F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.674 172.029L88.001 126.514V217.544L165.674 172.029Z",
    fill: "#FFAC42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.674 172.029L243.348 126.514V217.544L165.674 172.029Z",
    fill: "#FFAC42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.142 180.925L88 126.575H243.347L173.205 180.925C168.772 184.361 162.576 184.361 158.142 180.925Z",
    fill: "#FFBE6E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 106,
    width: 54.2724,
    height: 54.2724,
    rx: 27.1362,
    fill: "#D05354"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 108,
    width: 50.2724,
    height: 50.2724,
    rx: 25.1362,
    stroke: "white",
    strokeOpacity: 0.12,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.418 137.376C165.473 137.376 164.958 136.874 164.875 135.87L163.665 121.284C163.609 120.464 163.832 119.777 164.332 119.223C164.861 118.668 165.542 118.39 166.377 118.39C167.211 118.39 167.893 118.668 168.421 119.223C168.95 119.777 169.172 120.464 169.089 121.284L167.921 135.87C167.837 136.874 167.336 137.376 166.418 137.376ZM166.126 146.136C165.32 146.136 164.694 145.938 164.249 145.541C163.832 145.119 163.623 144.524 163.623 143.758V143.084C163.623 142.318 163.832 141.736 164.249 141.34C164.694 140.917 165.32 140.706 166.126 140.706H166.669C167.475 140.706 168.087 140.917 168.505 141.34C168.95 141.736 169.172 142.318 169.172 143.084V143.758C169.172 144.524 168.95 145.119 168.505 145.541C168.087 145.938 167.475 146.136 166.669 146.136H166.126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_2012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 326,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailMailSent);
export default __webpack_public_path__ + "static/media/fail-mail-sent.c1e96b36ff2f67649b0cbbeab1725b6d.svg";
export { ForwardRef as ReactComponent };